import React from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
//import "bootstrap/dist/css/bootstrap.css";
//import "startbootstrap-sb-admin-2/dist/css/sb-admin-2.css";
import 'startbootstrap-sb-admin-2/vendor/font-awesome/css/font-awesome.css';
import "./styles/main.css"
import "./index.css";

import {BrowserRouter, Route, Redirect, Switch} from "react-router-dom";
import Dashboard from "./containers/Dashboard";
import Login from "./containers/Login";

ReactDOM.render(
  <BrowserRouter basename="/#">
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route path="/dashboard" component={Dashboard} />
      <Redirect from="/" to="/dashboard" />
    </Switch>
  </BrowserRouter>
, document.getElementById('root'))

//registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js